import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// components
import ChefForm from "./_form";
import ChefList from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { setForm } from "../../../redux/actions/generalActions/formActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {setApp, clearState, setUdn, setCategory} from '../../../redux/actions/generalActions/mainActions'

function Chef (props) {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState()
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (udn) {
            props.setUdn(udn);
        }

        if (props.categoryCode !== null) {
            props.setCategory(props.categoryCode);
        }
    },[]);


    const createItem = () => {
        props.setForm();
        ModalFormContainer( ChefForm, {  } )
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <ChefList  />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearListState,
    clearState,
    setForm,
    setApp,
    setUdn,
    setCategory,
});

export default connect(mapStateToProps, mapActionsToProps)(Chef)